import React from 'react';
import { Component } from 'react';
export default class ConfluenceInlineComment extends Component {
  render() {
    const {
      reference,
      children
    } = this.props;
    return /*#__PURE__*/React.createElement("span", {
      "data-mark-type": "confluenceInlineComment",
      "data-reference": reference
    }, children);
  }
}